import React from 'react';
import UserAvatar from '../../../shared/components/ui/UserAvatar';
import TaskBadges from './TaskBadges';
import TaskProgress from './TaskProgress';
import { statusChipClass } from './taskWorkflow';
import { kindLabel, kindChipClass } from './permission';
import { formatRupees } from './budget';
import { displayRootStatus } from './taskTree';

const BUDGET_STATS = [
  { key: 'budget', label: 'Budget' },
  { key: 'allocated', label: 'Allocated' },
  { key: 'unallocated', label: 'Unallocated' },
  { key: 'actual', label: 'Actual' }
];

const ManagementTaskSummaryCard = ({
  task,
  actions,
  showBudget = false,
  onOpenApprovals,
  showApprovalsHint = false
}) => {
  if (!task) return null;
  const status = displayRootStatus(task);

  return (
    <div
      className={`bg-white rounded-xl border border-gray-200 shadow-sm ${
        onOpenApprovals
          ? 'cursor-pointer hover:border-[#346C75]/50 hover:shadow-md transition-shadow'
          : ''
      }`}
      onClick={onOpenApprovals}
    >
      <div className="p-6">
        <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-4">
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <h1 className="text-2xl font-bold text-gray-800">{task.title}</h1>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusChipClass(status)}`}>
                {status || '---'}
              </span>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${kindChipClass(task.kind)}`}>
                {kindLabel(task.kind)}
              </span>
              <TaskBadges badges={task.badges} className="flex flex-wrap gap-1" />
            </div>
            <p className="text-gray-500 text-sm mt-1">{task.description || 'No description'}</p>
            <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-gray-700">
              <div className="flex items-center gap-2">
                <span className="text-gray-500">Owner</span>
                <UserAvatar name={task.owner?.name} size={24} />
                <span className="font-medium">{task.owner?.name || '---'}</span>
              </div>
              <div className="w-52">
                <TaskProgress progress={task.progress} />
              </div>
            </div>
          </div>
          {actions ? (
            <div
              className="flex flex-wrap items-center gap-2 shrink-0"
              onClick={(e) => e.stopPropagation()}
            >
              {actions}
            </div>
          ) : null}
        </div>

        {showBudget && (
          <div className="mt-5 grid grid-cols-2 md:grid-cols-4 gap-3">
            {BUDGET_STATS.map(({ key, label }) => (
              <div key={key} className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2.5">
                <div className="text-[11px] uppercase tracking-wide text-gray-500">{label}</div>
                <div className="mt-0.5 text-sm font-semibold text-gray-800">{formatRupees(task[key])}</div>
              </div>
            ))}
          </div>
        )}

        {showApprovalsHint && (
          <p className="mt-4 text-xs text-[#346C75]">View subtasks awaiting approval</p>
        )}
      </div>
    </div>
  );
};

export default ManagementTaskSummaryCard;
